import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
  @media (min-width: 1024px) {
    gap: 30px;
  }
`;
export const StyledButton = styled.button`
  display: flex;
  width: 100%;
  padding: 15px !important;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.dark} !important;
  color: ${({ theme }) => theme.colors.dark} !important;
  background-color: transparent;
  font-size: ${({ theme }) => theme.fontSize.m};
  background-image: none !important;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  white-space: pre-wrap;
  &:hover {
    opacity: 0.7 !important;
    background-color: transparent !important;
    color: ${({ theme }) => theme.colors.dark} !important;
  }
  &.selected {
    background-color: ${({ theme }) => theme.colors.dark} !important;
    color: ${({ theme }) => theme.colors.white} !important;
    &:hover {
      opacity: 0.7 !important;
      background-color: ${({ theme }) => theme.colors.dark} !important;
      color: ${({ theme }) => theme.colors.white} !important;
    }
  }
`;
